define("analytics-resources/components/analytics-resource/chart-stats", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.ChartStatsComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cSL--chartStats" ...attributes>
    {{#each (if @isData @stats @defaultStats) as |stat|}}
      <div class="cCH--statGrid__item">
        <div class="cCH--statGrid__value qa-stat-grid-value">
          {{stat.value}}
        </div>
        <div class="cCH--statGrid__unit">
          {{stat.text}}
        </div>
      </div>
    {{/each}}
  </div>
  */
  {
    "id": "KGRwHpWj",
    "block": "[[[11,0],[24,0,\"cSL--chartStats\"],[17,1],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[52,[30,2],[30,3],[30,4]]],null]],null],null,[[[1,\"    \"],[10,0],[14,0,\"cCH--statGrid__item\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cCH--statGrid__value qa-stat-grid-value\"],[12],[1,\"\\n        \"],[1,[30,5,[\"value\"]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cCH--statGrid__unit\"],[12],[1,\"\\n        \"],[1,[30,5,[\"text\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[5]],null],[13]],[\"&attrs\",\"@isData\",\"@stats\",\"@defaultStats\",\"stat\"],false,[\"each\",\"-track-array\",\"if\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/chart-stats.hbs",
    "isStrictMode": false
  });
  const ChartStatsComponent = _exports.ChartStatsComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ChartStatsComponent);
});